import React from 'react';

import {AccessPortal} from 'presentation/pages/private/access-portal';

export const MakeAccessPortal: React.FC = () => <AccessPortal />;
